// extracted by mini-css-extract-plugin
export default {"Container":"About_Container__BaL3Z","Cards":"About_Cards__qP-2X"};